// extracted by mini-css-extract-plugin
export default {"container":"WAKqf","listItem":"_0GWR0","withFooter":"YK+7n"};